import React from "react";
import SEO from "../components/SEO";

const ImportantDates = () => {
  const dates = [
    {
      id: 1,
      title: "Abstract Submission Start",
      date: "August 15, 2026",
      description:
        "Portal opens for abstract submissions.",
      icon: (
        <svg
          className="w-5 h-5 text-white"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
          />
        </svg>
      ),
      color: "bg-blue-500",
      light: "bg-blue-50",
      text: "text-blue-600",
      border: "border-blue-200",
    },
    {
      id: 2,
      title: "Registration Opens",
      date: "August 15, 2026",
      description:
        "Conference registration portal goes live.",
      icon: (
        <svg
          className="w-5 h-5 text-white"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z"
          />
        </svg>
      ),
      color: "bg-purple-500",
      light: "bg-purple-50",
      text: "text-purple-600",
      border: "border-purple-200",
    },
    {
      id: 3,
      title: "Abstract Submission Deadline",
      date: (
        <span>
          <span className="line-through text-red-500 mr-2 opacity-75">30 September 2026</span>
          20th October, 2026
        </span>
      ),
      description:
        "Final day to submit your abstracts.",
      icon: (
        <svg
          className="w-5 h-5 text-white"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
      ),
      color: "bg-indigo-500",
      light: "bg-indigo-50",
      text: "text-indigo-600",
      border: "border-indigo-200",
    },
    {
      id: 4,
      title: "Early-Bird Registration Deadline",
      date: "September 30, 2026",
      description: "Last date to register at discounted early bird rates.",
      icon: (
        <svg
          className="w-5 h-5 text-white"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
      ),
      color: "bg-yellow-500",
      light: "bg-yellow-50",
      text: "text-yellow-600",
      border: "border-yellow-200",
    },
    {
      id: 5,
      title: "Accommodation Request Upto",
      date: (
        <span>
          <span className="line-through text-red-500 mr-2 opacity-75">30 September 2026</span>
          15th October, 2026
        </span>
      ),
      description:
        "Last day to request accommodation.",
      icon: (
        <svg
          className="w-5 h-5 text-white"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
          />
        </svg>
      ),
      color: "bg-teal-500",
      light: "bg-teal-50",
      text: "text-teal-600",
      border: "border-teal-200",
    },
    {
      id: 6,
      title: "Last Date for Registration",
      date: (
        <span>
          <span className="line-through text-red-500 mr-2 opacity-75">15 October 2026</span>
          20th October, 2026
        </span>
      ),
      description:
        "Final deadline for conference registration. No registrations accepted after this date.",
      icon: (
        <svg
          className="w-5 h-5 text-white"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
          />
        </svg>
      ),
      color: "bg-red-500",
      light: "bg-red-50",
      text: "text-red-600",
      border: "border-red-200",
    },
    {
      id: 7,
      title: "Conference Date",
      date: "19-21 November, 2026",
      description:
        "The main event of NCLC-2026.",
      icon: (
        <svg
          className="w-5 h-5 text-white"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
          />
        </svg>
      ),
      color: "bg-green-500",
      light: "bg-green-50",
      text: "text-green-600",
      border: "border-green-200",
    }
  ];

  return (
    <div className="min-h-screen bg-slate-50 py-16 pt-28 px-4 sm:px-6 lg:px-8 flex flex-col">
      <SEO title="Important Dates" />
      <div className="max-w-7xl mx-auto w-full flex-1 flex flex-col">
        {/* Header */}
        <div className="text-center mb-16">
          <h1 className="text-4xl md:text-5xl font-extrabold text-[#1e1b4b] mb-4 tracking-tight">
            Important Dates
          </h1>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Mark your calendars with these critical deadlines to ensure you
            don't miss out on any part of NCLC-2026.
          </p>
        </div>

        {/* Horizontal Timeline */}
        <div className="relative flex-1">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {dates.map((item, index) => (
              <div
                key={item.id}
                className="flex flex-col items-center relative z-10"
              >
                {/* Step Number */}
                <div className="text-xs font-bold text-gray-400 mb-2 uppercase tracking-widest">
                  Step {item.id}
                </div>

                {/* Icon Circle */}
                <div
                  className={`w-14 h-14 rounded-full ${item.color} flex items-center justify-center shadow-lg border-4 border-white mb-4 transition-transform duration-300 hover:scale-110`}
                >
                  {item.icon}
                </div>

                {/* Card */}
                <div
                  className={`w-full bg-white rounded-2xl border ${item.border} shadow-sm p-5 text-center hover:shadow-md transition-all duration-300 hover:-translate-y-1`}
                >
                  <span
                    className={`inline-block px-2 py-0.5 rounded-full text-xs font-bold uppercase tracking-wider ${item.light} ${item.text} mb-3`}
                  >
                    Upcoming
                  </span>
                  <h3 className="text-sm font-bold text-gray-900 mb-2 leading-snug">
                    {item.title}
                  </h3>
                  <div
                    className={`flex items-center justify-center gap-1 ${item.text} font-bold text-xs mb-3 ${item.light} px-2 py-1 rounded-lg`}
                  >
                    <svg
                      className="w-3.5 h-3.5"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                      />
                    </svg>
                    {item.date}
                  </div>
                  <p className="text-gray-500 text-xs leading-relaxed">
                    {item.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* CTA */}
        {/* <div className="mt-16 text-center bg-indigo-600 rounded-3xl p-10 shadow-xl text-white relative overflow-hidden">
          <div className="absolute top-0 right-0 w-64 h-64 bg-white opacity-5 rounded-full transform translate-x-1/3 -translate-y-1/3"></div>
          <div className="absolute bottom-0 left-0 w-40 h-40 bg-white opacity-5 rounded-full transform -translate-x-1/3 translate-y-1/3"></div>
          <h2 className="text-3xl font-bold mb-4 relative z-10">
            Stay Updated
          </h2>
          <p className="text-indigo-100 mb-8 max-w-xl mx-auto relative z-10">
            Make sure to join our mailing list or check back frequently to stay
            informed of any schedule updates.
          </p>
          <a
            href="/contact"
            className="inline-block px-8 py-3 bg-white text-indigo-600 font-bold rounded-full shadow-lg hover:bg-gray-50 transition-colors relative z-10"
          >
            Contact Support
          </a>
        </div> */}
      </div>
    </div>
  );
};

export default ImportantDates;
